<template>
  <div class="wrap">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
    >
      <el-form-item prop="period">
        <el-date-picker
          v-model="form.period"
          placeholder="Period"
          clearable
          type="daterange"
          :format="dateFormat"
          :value-format="formDateFormat"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="period">
        <el-select
          v-model="form.representative_ids"
          placeholder="Representatives"
          multiple
          clearable
          filterable
          style="width: 350px"
        >
          <el-option
            v-for="item in representativeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

      <div>
        <el-button type="primary" @click="build" class="align-top">Build</el-button>
        <slot name="buttons"></slot>
      </div>
    </el-form>
  </div>
</template>

<script>
import BaseParameters from '../parameters';

export default {
  extends: BaseParameters,

  props: {
    representativeOptions: Array,
  },

  data() {
    return {
      errors: {},
    };
  },

  computed: {
    /**
     * @return {String}
     */
    dateFormat() {
      return config('format.element.short.date');
    },

    /**
     * @return {String}
     */
    formDateFormat() {
      return config('format.datetime');
    },
  },

  methods: {
    /**
     * @return {object}
     */
    getForm() {
      return {
        period:null,
        representative_ids: [],
      };
    },
  }
}
</script>
